
export default {
  name: 'SectionsOverviewTwo',
  props: {
    sectionOverviewTwo: {
      type: Object,
      default: () => {},
    },
  },
}
